if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      // A slide past its end time goes before Swiper counts the slides (the page may be cached).
      this.querySelectorAll('.swiper-slide[data-hide-after]').forEach(slide => {
        if (Number(slide.dataset.hideAfter) * 1000 <= Date.now()) slide.remove();
      });

      this.initSlider(swiperOptions);

      window.addEventListener('shopify:section:load', e => {
        this.initSlider(swiperOptions);
      });
    }

    initSlider(swiperOptions) {
      // Rotation is driven by the timer in setupRotation(), not by Swiper's autoplay module:
      // Swiper 11 keeps a requestAnimationFrame loop running for as long as autoplay is on
      // (to publish autoplay.timeLeft every frame), which showed up as ~2.5 s of main-thread
      // time per Lighthouse run on the home page for a bar that changes every 4 s.
      this.interval = swiperOptions.autoplay && swiperOptions.autoplay.delay ? Number(swiperOptions.autoplay.delay) : 0;

      let sliderOptions = {
        slidesPerView: swiperOptions.slidesPerView || 1,
        resistanceRatio: 0.72,
        loop: swiperOptions.loop || false,
        allowTouchMove: swiperOptions.allowTouchMove || true,
        autoplay: false,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 'auto',
            loop: swiperOptions.loopDesktop || swiperOptions.loop || false,
          }
        }
      };

      this.slider = new Swiper(this, sliderOptions);
      if (this.interval > 0) this.setupRotation();
    }

    // Rotation pauses under the mouse, while keyboard focus is inside (WCAG 2.2.2), while the
    // bar is scrolled out of view or the tab is hidden; visitors who ask for reduced motion get
    // a still bar. A swipe restarts the countdown, as Swiper's autoplay did.
    setupRotation() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.focused = false;
      this.onScreen = true;

      if (!this.rotationBound) {
        this.rotationBound = true;
        this.addEventListener('mouseenter', () => { this.hovered = true; });
        this.addEventListener('mouseleave', () => { this.hovered = false; });
        this.addEventListener('focusin', () => { this.focused = true; });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.focused = false;
        });
        document.addEventListener('visibilitychange', () => this.schedule());
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(entries => {
            this.onScreen = entries.some(entry => entry.isIntersecting);
            this.schedule();
          }).observe(this);
        }
      }
      this.slider.on('slideChange', () => this.schedule());
      this.schedule();
    }

    // One pending timeout at a time; a tick that finds the bar paused only re-arms itself.
    schedule() {
      clearTimeout(this.timer);
      if (this.reducedMotion || !this.interval) return;
      this.timer = setTimeout(() => this.tick(), this.interval);
    }

    tick() {
      const slider = this.slider;
      const paused = this.hovered || this.focused || !this.onScreen || document.hidden;
      if (slider && !slider.destroyed && !paused) {
        if (slider.isEnd && !slider.params.loop) slider.slideTo(0);
        else slider.slideNext();
      }
      this.schedule();
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
